import { Injectable } from '@angular/core';

import { IMessage, IRxStompPublishParams, RxStomp, RxStompConfig, StompHeaders } from '@stomp/rx-stomp';

import { Observable, Subscription, first } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {

  private _subscriptions: {[key:string]: Subscription} = {};

  private _rxStomp: RxStomp | null = null;

  public async connect(): Promise<void> {
    const rxStompConfig: RxStompConfig = {

      brokerURL: environment.wsURL,

      /*
      // Headers
      // Typical keys: login, passcode, host
      connectHeaders: {
        login: 'guest',
        passcode: 'guest',
      },
      */

      // How often to heartbeat?
      // Interval in milliseconds, set to 0 to disable
      heartbeatIncoming: 0, // Typical value 0 - disabled
      heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

      // Wait in milliseconds before attempting auto reconnect
      // Set to 0 to disable
      // Typical value 500 (500 milli seconds)
      reconnectDelay: 200,

    };

    return new Promise<void>((resolve: () => void) => {
      this._rxStomp = new RxStomp();
      this._rxStomp.configure(rxStompConfig);
      this._rxStomp.activate();
      
      this._rxStomp.connected$.pipe(first()).subscribe({
        next: () => {
          resolve();
        },
        error: (error) => {
          console.error('Error while connecting to WebSocket:', error);
          resolve();
        }
      });
    });
  }

  public disconnect(): void {
    Object.keys(this._subscriptions).forEach((key: string) => {
      this._subscriptions[key].unsubscribe();
    });

    if (this._rxStomp === null) {
      return;
    }

    this._rxStomp.deactivate();
    this._rxStomp = null;
  }

  public publish(parameters: IRxStompPublishParams): void {
    if (this._rxStomp === null) {
      return;
    }
    this._rxStomp.publish(parameters);
  }

  public watch(destination: string, headers?: StompHeaders): Observable<IMessage> {
    if (this._rxStomp === null) {
      return new Observable<IMessage>();
    }
    return this._rxStomp.watch(destination, headers);
  }

  public subscribe(key: string, subscription: Subscription): void {
    this.unsubscribe(key);
    this._subscriptions[key] = subscription;
  }

  public unsubscribe(key: string): void {
    if (this._subscriptions[key] !== undefined && this._subscriptions[key] !== null) {
      this._subscriptions[key].unsubscribe();
      delete this._subscriptions[key];
    }
  }
}
